import { useMemo } from "react";

import Role from "@mapmycustomers/shared/enum/Role";
import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

const useParentUserIds = (
  allTeams: Team[],
  allUsers: User[],
  selectedUsers: User[],
  selectedTeams: Team[] | undefined,
  teamsForSelectedUsers: Team["id"][]
): Array<User["id"]> =>
  useMemo(() => {
    if (selectedTeams && selectedTeams.length > 0) {
      return allUsers.map(({ id }) => id);
    }
    if (
      teamsForSelectedUsers.length === 1 &&
      selectedUsers.every((user) => user.teams.length > 0 && user.role.key !== Role.OWNER)
    ) {
      return allTeams
        .find((team) => team.id === teamsForSelectedUsers[0])!
        .users.map(({ id }) => id);
    }
    const selectedUserIdsSet = new Set(selectedUsers.map(({ id }) => id));

    return Array.from(
      new Set(
        allTeams
          .find(({ users }) => users.some(({ id }) => selectedUserIdsSet.has(id)))
          ?.users.map(({ id }) => id) ?? []
      )
    );
  }, [allTeams, allUsers, selectedTeams, selectedUsers, teamsForSelectedUsers]);

export default useParentUserIds;
